export const SequentialNotice = () => (
    <p>
        <strong>
            Please note this course is sequential, meaning the Modules need to be completed in
            order. You can de-select modules using the checkboxes to remove a Participant from the
            attendance list, but this will de-select all subsequent Modules as well. For example, if
            a participant is attending a sequential course with 5 modules, if the participant is
            removed from attending module 3, the participant will automatically also be removed from
            modules 4 and 5.
        </strong>
    </p>
);
